export default "__VITE_ASSET__CVWoVmHn__"